import { render, staticRenderFns } from "./ProgramListFilter.vue?vue&type=template&id=35a8996c&scoped=true"
import script from "./ProgramListFilter.vue?vue&type=script&lang=js"
export * from "./ProgramListFilter.vue?vue&type=script&lang=js"
import style0 from "./ProgramListFilter.vue?vue&type=style&index=0&id=35a8996c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a8996c",
  null
  
)

export default component.exports